import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getOfflineQrCode = async (id, masterPassId) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `book_groups/${id}/offline_qrcode?master_pass_id=${masterPassId}`
    );

    let responseTime = null;
    if (resp.data && typeof resp.data === "object" && resp.headers) {
      const dateHeader = resp.headers.date || resp.headers.Date;
      if (dateHeader) {
        responseTime = Math.floor(new Date(dateHeader).getTime() / 1000);
      }
    }
    if (!responseTime) {
      // フォールバック: responseからunix時間が取得できない場合は現在時刻を使用
      responseTime = Math.floor(Date.now() / 1000);
    }
    resp.data.rT = responseTime;
    return resp.data;
  } catch (err) {
    throw err;
  }
};
